export default __webpack_public_path__ + "media/images/quickbooks-d84c9da8b2dde7e2985e627c60d7574e.png";